module.exports = __webpack_public_path__ + "img/footerERWE.12be0ab0.png";